import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { formatDate } from "utils";
import { FormattedMessage, useIntl } from "react-intl";
import Card from "components/Card";
import PageTitle from "components/PageTitle";
import { PageWrapper } from "components/Containers";
import { Grid } from "components/Containers";
import { CodeChallengeImportButton, CodeChallengesList } from "components/CodeChallenges";

/**
 * CodeChallenges
 */
const CodeChallenges = () => {
  const intl = useIntl();
  const [lastImportAt, setLastImportAt] = useState(null);

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Settings.CodeChallenges.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            subtitle={<FormattedMessage id="Settings.CodeChallenges.H1" />}
            actionBar={
              <>
                {lastImportAt && (
                  <FormattedMessage
                    id="Settings.CodeChallenges.LastImported"
                    values={{ date: formatDate(lastImportAt, "MMM DD, YYYY", true, true) }}
                  />
                )}
                <CodeChallengeImportButton />
              </>
            }
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <Card>
            <CodeChallengesList setLastImportAt={setLastImportAt} />
          </Card>
        </Grid.col>
      </Grid>
    </PageWrapper>
  );
};

export default CodeChallenges;
